import { render, staticRenderFns } from "./userauthtable.vue?vue&type=template&id=2d0fbb94&scoped=true&"
import script from "./userauthtable.vue?vue&type=script&lang=js&"
export * from "./userauthtable.vue?vue&type=script&lang=js&"
import style0 from "./userauthtable.vue?vue&type=style&index=0&id=2d0fbb94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0fbb94",
  null
  
)

export default component.exports